import * as React from "react"
import { cn } from "../../utils/helpers"
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "./tooltip"

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    tooltipText?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, style, tooltipText, ...props }, ref) => {

    const inputElement = (
        <input
            type={type}
            className={cn(
               "flex h-9 min-w-0 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base text-foreground shadow transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                className
            )}
            ref={ref}
            {...props}
        />
    );

    if (!tooltipText) return inputElement;

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>{inputElement}</TooltipTrigger>
                <TooltipContent side="top" align="end" sideOffset={0} className="z-[1400]">
                    {tooltipText}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
})
Input.displayName = "Input"

export { Input }
